// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader-wrapper[data-v-772feb1e]{display:flex;justify-content:center;margin:3em 0 1em 0}.qrcode-wrapper[data-v-772feb1e]{width:300px;margin:0 auto}.autoconvert-warning .autoconvert-warning--account[data-v-772feb1e]{font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
